import { useTheme } from '@mui/material';

import { MenuIconProps } from './menu-icon-props.interface';

export const WalletMenuIcon = ({ stroke, filled, ...props }: MenuIconProps) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return filled ? (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.9004 4.15039C19.3144 4.15059 19.6504 4.4863 19.6504 4.90039C19.6504 5.31448 19.3144 5.65019 18.9004 5.65039H5.65039C5.09811 5.65039 4.65039 6.09811 4.65039 6.65039C4.65039 7.20268 5.09811 7.65039 5.65039 7.65039H19.1006C20.0668 7.65069 20.8506 8.43408 20.8506 9.40039V18.1006C20.8505 19.0668 20.0668 19.8503 19.1006 19.8506H6.30078C4.56108 19.8506 3.15039 18.4399 3.15039 16.7002V6.65039C3.15039 5.26968 4.26968 4.15039 5.65039 4.15039H18.9004Z"
        fill={strokeColor}
      />
    </svg>
  ) : (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.9 4.90039H6.30002C4.97454 4.90039 3.90002 5.97491 3.90002 7.30039V16.7004C3.90002 18.0259 4.97454 19.1004 6.30002 19.1004H19.1C19.6523 19.1004 20.1 18.6527 20.1 18.1004V9.40039C20.1 8.84811 19.6523 8.40039 19.1 8.40039H18.9H7.60002"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
